module.exports = "#apply {\r\n    padding-top: 26px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/clients/client-trip-history/client-trip-history.component.css
// module id = ./src/app/components/clients/client-trip-history/client-trip-history.component.css
// module chunks = main